import { axios } from "@Root/API";

export const sendContactUsForm = data => {
  return axios.post("email/list-with-error", data);
};
